const STATES = [
  'Illinois',
  'Alaska',
  'Nebraska',
  'New York',
  'Pennsylvania',
  'Rhode Island',
  'Arkansas',
  'Florida',
  'Missouri',
  'Utah',
  'Kansas',
  'South Dakota',
  'North Dakota',
  'Maryland',
  'New Mexico',
  'California',
  'Arizona',
  'South Carolina',
  'Tennessee',
  'Colorado',
  'District of Columbia',
  'Indiana',
  'Texas',
  'Georgia',
  'Oklahoma',
  'Kentucky',
  'Minnesota',
  'Alabama',
  'Louisiana',
  'Mississippi',
  'Iowa',
  'Wisconsin',
  'New Jersey',
  'New Hampshire',
  'Maine',
  'North Carolina',
  'Massachusetts',
  'Wyoming',
  'West Virginia',
  'Ohio',
  'Vermont',
  'Michigan',
  'Connecticut',
  'Hawaii',
  'Virginia',
  'Montana',
  'Delaware',
  'Nevada',
  'Idaho',
  'Oregon'
];
const BUNDLEADDONS = [
  'Sports Package',
  'Movie Package',
  'International Channels',
  'American Top Channels',
  'Regional Channels',
  'Family Package',
  'HD Streaming',
  'Direct TV Now',
  'Netflix',
  'HBO',
  'Roku App',
  'Live TV',
  'Fire TV App',
  'Apple TV App',
  'Android TV App',
  'Amazon Prime',
  'Hulu',
  'Tinder',
  'Insurance',
  'Tidle'
];
const EMPLOYEES = [
  {
    id: '5af9a9b7a0ae5835a4f14afa',
    fullname: 'Anu Sura',
    email: 'anu@billtrim.com'
  },
  {
    id: '5e4aa1d03936691cd990f9b1',
    fullname: 'Melanie Arcaya',
    email: 'melaniearcaya611@gmail.com'
  },
  {
    id: '5e4aa2faac183c4dc9d47d48',
    fullname: 'Roldan Bisquera',
    email: 'roldanbisquera611@gmail.com'
  },
  {
    id: '5e4aa312393669cf1290f9f0',
    fullname: ' kelvin Garcia',
    email: 'gkelvinrey@gmail.com'
  },
  {
    id: '5af9a9b7a0ae5835a4f14afc',
    fullname: 'Dipesh Desai',
    email: 'dipesh@billtrim.com'
  },
  {
    id: '5bbaf919d367840c67c9c338',
    fullname: 'Thyagarajan C',
    email: 'thyagarajan.billtrim@gmail.com'
  },
  {
    id: '5e18230bf4a83242f2298dcb',
    fullname: 'Damodar Demo',
    email: 'demo.billtrim@gmail.com'
  },
  {
    id: '5e1d5ea71d7daf39145c4512',
    fullname: 'Shreyash Asthana',
    email: 'shreyash.billtrim@gmail.com'
  },
  {
    id: '5e4aa0f8393669042790f9ac',
    fullname: 'Mc Jordan Costan',
    email: 'mcjordan611@gmail.com'
  },
  {
    id: '5e4aa14d3936692cf090f9ad',
    fullname: 'Shyfrenel Mamugay',
    email: 'smamugay611@gmail.com'
  },
  {
    id: '5e4aa189ac183c7036d47d19',
    fullname: 'Evan Jessie Sabilla',
    email: 'eabilla611@gmail.com'
  },
  {
    id: '5e4aa198393669a65c90f9ae',
    fullname: 'Regine Kaye Peregrino',
    email: 'rkperegrino611@gmail.com'
  },
  {
    id: '5e4aa1b239366905c790f9af',
    fullname: 'Regine Sayson',
    email: ' reginesayson5@gmail.com'
  },
  {
    id: '5e4aa1c2393669eda590f9b0',
    fullname: 'Danilo Amo',
    email: 'daniloamo611@gmail.com'
  },
  {
    id: '5e4aa1e2ac183c953bd47d31',
    fullname: 'Aireen Castaños',
    email: 'acastanos611@gmail.com'
  },
  {
    id: '5e4aa1f6ac183c08a3d47d32',
    fullname: 'Jonell Bisnar',
    email: 'bisnar611@gmail.com'
  },
  {
    id: '5e4aa224393669239f90f9b6',
    fullname: 'Kevin William Tiangco',
    email: 'kwtiangco@gmail.com'
  },
  {
    id: '5e4aa2d2ac183c291bd47d47',
    fullname: 'Shirween Tagab',
    email: 'shirweentagab611@gmail.com'
  },
  {
    id: '5e4aa32a393669459e90f9f1',
    fullname: 'Mark Jeraldine',
    email: 'nashang12345@gmail.com'
  },
  {
    id: '5e4aa33c39366989d290f9f2',
    fullname: 'Ricky Castillote',
    email: 'lutherjob25@gmail.com'
  },
  {
    id: '5e4aa34eac183c1be6d47d4c',
    fullname: 'Juntie Votacion',
    email: 'juntie.votacion611@gmail.com'
  },
  {
    id: '5e4aa35e393669aca990fa0a',
    fullname: 'Jason Lapasaran',
    email: 'jasonlapasaran611@gmail.com',
    FIELD4: ''
  },
  {
    id: '5e4aa23e39366978a490f9b7',
    fullname: 'Ethel Habanes',
    email: ' habanesgrace@gmail.com'
  },
  {
    id: '5e4aa2523936694b6090f9b8',
    fullname: 'Jasen Hallasgo',
    email: 'hallasgojasen@gmail.com'
  }
];
const onboardingTypeToNameMap = {
  1: 'first-bill-shark',
  2: 'default-asktrim-cc-mandate',
  3: 'billtrim-old',
  4: 'teacher-preachers-influencers',
  11: 'react',
  12: 'react',
  13: 'react',
  14: 'react',
  15: 'react',
  16: 'react',
  17: 'react',
  18: 'react',
  19: 'react',
  20: 'react',
  21: 'ios',
  22: 'ios',
  23: 'ios',
  24: 'ios',
  25: 'ios',
  26: 'ios',
  27: 'ios',
  28: 'ios',
  29: 'ios',
  30: 'ios',
  31: 'Manychat',
  32: 'Manychat',
  33: 'Manychat',
  34: 'Manychat',
  35: 'Manychat',
  36: 'Manychat',
  37: 'Manychat',
  38: 'Manychat',
  39: 'Manychat',
  40: 'Manychat',
  41: 'Default',
  42: 'Drake & Kevin',
  43: 'Galactic Fed',
  44: 'SVG',
  45: 'Kriya',
  46: 'Madrivo',
  47: 'Remo',
  48: 'NoBrainerAsset-Nemo',
  81: 'Landbot',
  91: 'Endless',
  101: 'Facebook',
  102: 'lemonade-bill-first',
  103: 'lemonade-cc-first'
};
const employeeTypeToRoleNameMap = [
  'SuperAdmin', // 0
  'CSRAdmin', // 1
  'CSR', // 2
  'NegotiatorAdmin', // 3
  'Negotiator', // 4
  'QAAdmin', // 5
  'QA', // 6
  'ChaserAdmin', // 7
  'Chaser', // 8
  'SuperNegotiator' // 9
];

const providerNumbers = {
  '5af9a9019b1f40176c989a2e': {
    providerName: 'ATT',
    numbers: ['1234567890', '9234924592']
  },
  '5af9a9019b1f40176c989a32': {
    providerName: 'T-Mobile',
    numbers: ['1234567890', '9234924592']
  },
  '5af9a9019b1f40176c989a36': {
    providerName: 'Sprint',
    numbers: ['1234567890', '9234924592']
  },
  '5af9a9019b1f40176c989a2a': {
    providerName: 'Verizon',
    numbers: ['1234567890', '9234924592']
  }
};

const ringcentralAgents = {
  '5ee39ae6bbe70a80bdd639e3': {
    type: 4,
    fullname: 'Daisy Opendo',
    email: 'daisyopendo611@gmail.com',
    username: 'BTrim_Nego9',
    callerId: '7328742255'
  },
  '5f7b27a64e7a93741fc9f7b1': {
    type: 4,
    email: 'orbisojenniferjoy611@gmail.com',
    fullname: 'Jennifer Joy Orbiso',
    username: 'BTrim_Nego_JOrbiso',
    callerId: '2815464552'
  },
  '5f7ca72660e802ad5b5f17f6': {
    type: 4,
    email: 'ciloecanonigo611@gmail.com',
    fullname: 'Cilo Elicor Canonigo',
    username: 'BillTrim_Nego_Canonigo',
    callerId: '6788585648'
  },
  '5fa96f85d581fa24e070b768': {
    type: 4,
    fullname: 'Garciano Marjun',
    email: 'marjunpagargarciano611@gmail.com',
    username: 'BTrim_Agent_mgarciano',
    callerId: '3095824741'
  }
};

module.exports = {
  STATES,
  BUNDLEADDONS,
  EMPLOYEES,
  onboardingTypeToNameMap,
  employeeTypeToRoleNameMap,
  providerNumbers,
  ringcentralAgents
};



//////////////////
// WEBPACK FOOTER
// ./config/common-lists.js
// module id = ./config/common-lists.js
// module chunks = main